import * as React from 'react';
import { Divider as MuiDivider } from '@material-ui/core';

const Divider = ({ ...other }) => {
  return <MuiDivider aria-hidden="true" {...other} />;
};

export default Divider;
